import { useQuery } from '@tanstack/react-query';
import { BillingService } from '@/services/domain/BillingService';

export const subscribeInfoQueryKey = ['subscribeInfo'] as const;

export const useSubscribeInfo = () => {
  return useQuery({
    queryKey: subscribeInfoQueryKey,
    queryFn: () => BillingService.getSubscribeInfo(),
    // Global config disables refetchOnMount, but premium can change on other
    // devices/platforms, so reopening the Plans page must pull fresh data.
    refetchOnMount: 'always',
  });
};
